var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_box"},_vm._l((_vm.arr),function(item,index){return _c('div',{key:index,staticClass:"img_boxsss",on:{"click":function($event){return _vm.type_fen(item.id)}}},[_c('div',{staticClass:"nei_box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(item.names))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }